import {useStoredMe} from "../store/me";
import {useStoredResidentHouseholdId} from "../store/resident-context";

/** Selected unit for residents (`properties[].memberships[]`); null for staff or before init. */
export default function useResidentHouseholdId(): number | null {
  const me = useStoredMe();
  const householdId = useStoredResidentHouseholdId();

  if (!me?.isResident) return null;
  return householdId;
}
